import { type ReactNode } from 'react';
import dibsCss from 'dibs-css';
import { BuyerProductTileShimmer } from 'dibs-buyer-product-tile/exports/BuyerProductTileShimmer.ts';
import { TILE_SIZES } from 'dibs-buyer-product-tile/exports/BuyerProductTile.ts';

export const renderUserRecommendationsGridShimmers = (
    count: number,
    keyPrefix: string
): ReactNode[] =>
    Array.from({ length: count }, (_, index) => (
        <div key={`${keyPrefix}-${index}`} className={dibsCss.minW0}>
            <BuyerProductTileShimmer size={TILE_SIZES.medium} />
        </div>
    ));
